window.addEventListener('alpine:init', () => {
  var {
    getElFromHtmlString,
    removeSectionWrapper,
    scrollIntoViewWithinEl,
    getDefaultAlpineMorphLifecycleHooks
  } = Alpine.store('utilities');

  var defaultAlpineMorphLifecycleHooks = getDefaultAlpineMorphLifecycleHooks();

  function productMain(data = {}) {
    return {
      ...data,

      isLoadingProductMain: false,

      isVariantUnavailable: false,

      selectedVariantId: +(new URL(location).searchParams.get('variant')),

      init() {
        this.onProductFormSubmitStart = this.onProductFormSubmitStart.bind(this);
        this.onProductFormSubmitEnd = this.onProductFormSubmitEnd.bind(this);
        this.onProductFormSelectedOptionsChange = this.onProductFormSelectedOptionsChange.bind(this);

        window.addEventListener('productformsubmitstart', this.onProductFormSubmitStart);
        window.addEventListener('productformsubmitend', this.onProductFormSubmitEnd);
        window.addEventListener('productformselectedoptionschange', this.onProductFormSelectedOptionsChange);
      },

      destroy() {
        window.removeEventListener('productformsubmitstart', this.onProductFormSubmitStart);
        window.removeEventListener('productformsubmitend', this.onProductFormSubmitEnd);
        window.removeEventListener('productformselectedoptionschange', this.onProductFormSelectedOptionsChange);
      },

      onProductFormSubmitStart() {
        this.isLoadingProductMain = true;
      },

      onProductFormSubmitEnd() {
        this.isLoadingProductMain = false;
      },

      onProductFormSelectedOptionsChange(event) {
        this.renderAndUpdateUrl({ selectedOptionValues: event.detail.selectedOptionValues });
      },

      renderAndUpdateUrl({ baseUrl = location, selectedOptionValues}) {
        this.isLoadingProductMain = true;

        var sectionUrl = new URL(baseUrl);

        sectionUrl.searchParams.set('section_id', this.sectionId);

        sectionUrl.searchParams.set('option_values', selectedOptionValues.join(','));

        fetch(sectionUrl)
          .then((res) => res.text())
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            var sectionIdEl = getElFromHtmlString(res, '[name="id"]');

            var url = new URL(baseUrl);

            if (sectionIdEl.value) {
              url.searchParams.set('variant', sectionIdEl.value);
              this.selectedVariantId = +(sectionIdEl.value);
              this.isVariantUnavailable = false;
            } else {
              url.searchParams.delete('variant');
              this.selectedVariantId = null,
              this.isVariantUnavailable = true;
            }

            window.history.replaceState(null, null, url);

            Alpine.morph(this.$root, sectionHtml, defaultAlpineMorphLifecycleHooks);

            dispatchEvent(new CustomEvent('productmainrendersuccess', {
              detail: {
                variantId: +(sectionIdEl.value)
              }
            }));
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingProductMain = false;
          });
      },

      scrollToSelectedMedia({ selectedVariantId = this.selectedVariantId,  variantIds, behavior }) {
        if (variantIds.includes(selectedVariantId)) {
          scrollIntoViewWithinEl(this.$el, behavior);
        }
      }
    };
  };

  Alpine.data('productMain', productMain);
});
